import type { FormSelectOption } from '../components/Reusables/FormSelectField.types';

type LocationLike = {
  _id?: string;
  bp_location_name?: string;
  bp_location_is_system_generated?: boolean;
};

/**
 * Body `bp_purchase_order_location_id` must match session location unless
 * All Locations is on (`x-all-locations: true`). Edit keeps the PO location
 * so single-location mode cannot overwrite it with the current session.
 */
export function resolvePurchaseOrderLocationId(params: {
  isEdit: boolean;
  isAllLocations: boolean;
  formLocationId: string;
  currentLocationId: string;
}): string {
  const formId = String(params.formLocationId || '').trim();
  const currentId = String(params.currentLocationId || '').trim();
  if (params.isAllLocations) {
    return formId || currentId;
  }
  if (params.isEdit) {
    return formId || currentId;
  }
  return currentId;
}

export function canSelectPurchaseOrderDeliveryLocation(
  isAllLocations: boolean,
): boolean {
  return isAllLocations === true;
}

export function toPurchaseOrderLocationOptions(
  locations: LocationLike[] | null | undefined,
  keepIds: Array<string | null | undefined> = [],
): FormSelectOption[] {
  const kept = new Set(
    keepIds.map(id => String(id || '').trim()).filter(Boolean),
  );
  return (locations || [])
    .filter(loc => {
      const id = String(loc?._id || '').trim();
      if (!id) return false;
      if (kept.has(id)) return true;
      return loc?.bp_location_is_system_generated !== true;
    })
    .map(loc => ({
      label: String(loc?.bp_location_name || 'Unnamed location'),
      value: String(loc?._id),
    }));
}
